<template>
    <div class="agreeWrap">
        <div>
            <h1>{{domain}} Account Termination Agreement</h1>
            <div class="bd">
                <p>
                    [Important Reminder] Dear user, terminating your {{domain}} account is an irreversible action. After you terminate your account, you will no longer be able to log in or retrieve your user history, favorites, purchases, or any other data related to your account. Your personal information will either be deleted or fully anonymized (unless otherwise required by law). Once your account has been terminated, it cannot be restored. Please proceed with care.<br>
                    If you are sure that you wish to terminate your {{domain}} account, please carefully read and understand this agreement in its entirety. If you indicate that you accept this agreement and apply for account termination, you will be deemed to have consented to and are willing to comply with all the contents of this agreement.
                    I. In order to protect the security of your account and your related rights and interests, you must first check and confirm that the account you wish to terminate has met the following conditions before you apply for account termination:
                    1. That the {{domain}} account you are applying to terminate is owned and accessed by you, and that it complies with all account-related terms in our Terms of User Service.<br>
                    2. That the account is in a secure state, that it can be used normally and has not had its integrity compromised in any way.<br>
                    3, That you have properly settled the relevant rights and interests that you hold via the account. If they are not settled at the time of account termination, you will be deemed to have voluntarily waived the relevant rights and interests.<br>
                    4. That there are no outstanding payments associated with the account.<br>
                    5. The account's coin balance is not negative.<br>
                    6. That the account is not involved in any litigation, lawsuits, reports, or any other disputes.<br>
                    II. You understand and confirm that the termination of your {{domain}} account is associated with the following consequences, and that you will bear the consequences yourself:<br>
                    1. You will no longer be able to log in or use the account.<br>
                    2. Unless  otherwise required by law, the personal information that you have stored in your account will be deleted or fully anonymized. You will no longer be able to retrieve your personal information, and you will not have the right to ask us to retrieve the information for you. The abovemented personal information includes your avatar, username, purchase history, browsing history, etc.<br>
                    3. You understand and confirm that the termination of your {{domain}} account also includes the termination of all related rights and interests that you hold via the account, and that you will bear all consequences that arise as a result. The abovementioned rights and interests include books services that you purchased, unused virtual currency, virtual goods, etc.<br>
                    4. Once your account is terminated, it cannot be restored. As such, we would like to remind you to back up all necessary information before applying for account termination.<br>
                    5. Once your account is terminated, you will no longer be bound to our Terms of User Service agreement. However, you will still be responsible for all actions undertaken using the account before it was terminated.<br>

                    III. You understand and confirm that, if your account is involved in a dispute or fails to meet our termination conditions at any point after you apply for termination, or if we need to verify certain aspects of or related to your account, we reserve the right to suspend the account termination process for you.<br>
                    IV. We will complete verifying and processing your account termination within 30 days of receiving your termination request. If you have any questions during the account termination process, please seek assistance from one of our staff members.<br>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "",
        data () {
            return {
                flag: 'zh_TW ',
                domain: 'Wakenovel'
            }
        },
        mounted () {
            if (this.$route.query.lang) {
                this.flag = this.$route.query.lang
            } else {
                this.flag = 'zh_TW'
            }
            if (window.location.host == "www.wakenovel.com") {
                this.domain = "Wakenovel"
            } else if (window.location.host == "www.gemnovel.com") {
                this.domain = "Gemnovel"
            } else if (window.location.host == "www.inktale.net") {
                this.domain = "InkTale"
            } else if (window.location.host == "www.adoread.com") {
                this.domain = "Adoread"
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .agreeWrap
        font-size 0.5rem
        padding 0.8rem
        line-height 1.3rem
        background #fff;
        min-height 100vh;
        height auto;
        h6
            padding 0.2rem 0
            font-size 0.7rem
        li
            margin 0.5rem 0
    .textIndet10{
        text-indent 10px;
    }
    .textIndet20{
        text-indent 20px;
    }
</style>
